import React from 'react';
import {
  bool,
  node,
  shape,
  string,
} from 'prop-types';

import { Container, Label, Value } from './card-label-value.style';

/**
 * Label - Value pair component
 * @param {object} param - Object containing props
 * @param {string} param.label - Label to show
 * @param {string} param.value - Value to show
 * @param {func} param.onEdit - Handles editing this form
 * @param {obhject} param.editOptions - Options to enable editing on field
 * @param {object} param.options - LabelValue options
 * @return {element} - Label - value pair component
 */
const LabelValue = ({
  label,
  value,
  editOptions,
  options,
}) => (
  <Container stacked={options.stacked} columnTemplate={options.gridColumnTemplate}>
    <Label darkBlueText={options.stacked}>{label}</Label>
    {!editOptions.editing && <Value>{value}</Value>}
    {editOptions.editing && editOptions.editNode}
  </Container>
);

LabelValue.propTypes = {
  label: string.isRequired,
  value: string,
  editOptions: shape({
    editing: bool,
    editNode: node,
  }),
  options: shape({
    gridColumnTemplate: string,
    stacked: bool,
  }),
};

LabelValue.defaultProps = {
  editOptions: {
    editing: false,
    editNode: null,
  },
  options: {
    gridColumnTemplate: '1fr 1fr',
    stacked: false,
  },
  value: '',
};

export default LabelValue;
